import { useMutation } from '@tanstack/react-query';
import { requestStartupJoin } from '../api/startups.api';

/**
 * "Request Access" mutation on `StartupAlreadyExistsState` (follow-up to
 * FR-13's block). No `onSuccess` navigation - the caller stays on the same
 * card, which swaps its CTA to a disabled "Request Sent" state.
 */
export function useRequestStartupJoin() {
  return useMutation({ mutationFn: requestStartupJoin });
}
